<div class="follow-up-form">
  <p>
    Job Title: {{ jobTitle }} <br />Company: {{ companyName }} <br />Application ID: {{ applicationId }}
  </p>

  <!-- Invitation Form (Create/Edit) -->
  <form [formGroup]="invitationForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="invited_at">{{ t.LABEL_INVITED_AT }}</label>
      <input id="invited_at" type="datetime-local" formControlName="invited_at" />
    </div>
    <div class="form-group">
      <label for="status">{{ t.LABEL_STATUS }}<span style="color: red">*</span></label>
      <select id="status" formControlName="status" required>
        <option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="notes">{{ t.LABEL_NOTES }}</label>
      <textarea id="notes" formControlName="notes" rows="2" placeholder="{{ t.PLACEHOLDER_OPTIONAL_NOTES }}"></textarea>
    </div>
    <div class="form-actions">
      <button type="submit" [disabled]="invitationForm.invalid || isSubmitting">
        {{ editingInvitationId ? (isSubmitting ? t.BUTTON_SAVING : t.BUTTON_UPDATE) : (isSubmitting ? t.BUTTON_SAVING : t.BUTTON_CREATE) }}
      </button>
      <button type="button" (click)="cancelEdit()">{{ t.BUTTON_CANCEL }}</button>
    </div>
  </form>

  <!-- Invitation List -->
  <div class="invitation-list" *ngIf="invitations.length">
    <table>
      <thead>
        <tr>
          <th>{{ t.TABLE_STATUS }}</th>
          <th>{{ t.TABLE_NOTES }}</th>
          <th>{{ t.TABLE_INVITED_AT }}</th>
          <th>{{ t.TABLE_ACTIONS }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let inv of invitations">
          <td>{{ getStatusLabel(inv.status) }}</td>
          <td>
            <span
              [title]="inv.notes"
              class="notes-tooltip"
            >
              {{ inv.notes?.length > 40 ? (inv.notes | slice:0:40) + '…' : inv.notes }}
            </span>
          </td>
          <td>{{ toDisplayDate(inv.invited_at) | date:'medium' }}</td>
          <td>
            <button type="button" class="icon-btn" (click)="editInvitation(inv)" [attr.title]="t.TOOLTIP_EDIT">
              <i class="bi bi-pencil"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!invitations.length && !isLoading" class="empty-state">
    {{ t.EMPTY_STATE_NO_INVITATIONS }}
  </div>
  <div *ngIf="isLoading">{{ t.LOADING }}</div>
  <div *ngIf="error" class="error">{{ error }}</div>
</div>
